import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientOnboarding = React.lazy(
    () => import(/* webpackChunkName: "client-onboarding" */ '../../../../containers/Client/Onboarding')
);

export const ClientOnboardingRoutes: RouteObject = {
    path: 'onboarding',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientOnboarding />
        </React.Suspense>
    )
};
